import React from 'react';
import clsx from 'clsx';
import { Theme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';

import { Button } from '@mui/material';

import useVideoContext from '../../../hooks/useVideoContext/useVideoContext';

const useStyles = makeStyles()((theme: Theme) => ({
  button: {
    background: theme.brand,
    color: 'white',
    '&:hover': {
      background: '#600101',
    },
  },
}));

export default function EndCallButton(props: { className?: string }) {
  const { classes } = useStyles();
  const { room } = useVideoContext();

  return (
    <Button
      onClick={() => room!.disconnect()}
      className={clsx(classes.button, props.className)}
      data-cy-disconnect
      style={{ backgroundColor: '#ff9327', color: 'white' }}
    >
      Disconnect
    </Button>
  );
}
